import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaDribbble } from "react-icons/fa";
import { useSelector } from "react-redux";

const SplashFooter = () => {
  const { currentCustomer } = useSelector((state) => state.store);
  return (
    <footer className="footer-area splash-footer">
      <div className="container">
        <div className="footer-bottom">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="footer-copyright">
                <span className="copyright-text">
                  © {new Date().getFullYear()}. Todos los derechos reservados
                  por{" "}
                  <a
                    href="https://gestionciudad.com/"
                    target="_blank"
                    rel="noopener external"
                  >
                    Gestion Ciudad
                  </a>
                  .
                </span>
              </div>
            </div>
            <div className="col-lg-2">
              <ul className="footer-social list-unstyled">
                <li>
                  <a href="https://www.facebook.com/">
                    <FaFacebookF />
                  </a>
                </li>
                <li>
                  <a href="https://dribbble.com/">
                    <FaDribbble />
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-5">
              <div className="footer-bottom-link">
                <ul className="list-unstyled">
                  <li>
                    <a href="#">{currentCustomer?.name}</a>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/privacy-policy"}>
                      Política de Privacidad
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SplashFooter;
